import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=ed0cbfd6&scoped=true&"
import script from "./purchase.vue?vue&type=script&lang=js&"
export * from "./purchase.vue?vue&type=script&lang=js&"
import style0 from "./purchase.vue?vue&type=style&index=0&id=ed0cbfd6&scoped=true&lang=scss&"
import style1 from "./purchase.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0cbfd6",
  null
  
)

export default component.exports